import { Component } from '@angular/core';
import { WhatsappService } from '../whatsapp.service';
import { WaMessage } from '../wa-message/wa-message';
import { WhatsappMessage } from '../../models/whatsapp';
import { AppModule } from '../../app.module';

@Component({
  selector: 'app-wa-conversation',
  imports: [WaMessage, AppModule],
  templateUrl: './wa-conversation.html',
  styleUrl: './wa-conversation.less'
})
export class WAConversation {

  constructor(public whatsappService: WhatsappService) {}

  public needsTabs(): boolean {
    return this.whatsappService.messages.some(msg => msg.incidentId !== 0);
  }

  public getIncidentNumber(): string {   
    return this.whatsappService.messages.filter(msg => msg.incidentId !== 0)[0].incidentNumber ? this.whatsappService.messages.filter(msg => msg.incidentId !== 0)[0].incidentNumber! : "";
  }

  public getOpenIncidentMessages(): WhatsappMessage[] {
    return this.whatsappService.messages.filter(msg => msg.incidentId === 0);
  }

  public getMessagesForIncident(incidentId: number = 0): WhatsappMessage[] {
    if (incidentId === 0) {
      incidentId = this.whatsappService.currentIncidentId()!;
    }
    return this.whatsappService.messages.filter(msg => msg.incidentId === incidentId);
  }

  public clearAllOpenMessages() {
    this.whatsappService.clearOpenMessages();
  }

  public onMessageRemoved(message: WhatsappMessage) {
    this.whatsappService.removeMessage(message);
  }
}
